import { Pipe, PipeTransform, Inject } from '@angular/core';
import * as moment from 'moment';
import { LOCALE_ID } from '@angular/core';

@Pipe({
  name: 'tipoSocio'
})
export class TipoSocioPipe implements PipeTransform {

  lang: string; 

  constructor(@Inject(LOCALE_ID) locale: string) {
    this.lang = locale;
  }

  transform(socio: any, args?: any): string {
    if (!socio || !socio.natoIl) {
      return this.lang == "en" ? "loyal friend"  : "amico fedele";
    }
      

    const age = moment().diff(moment(socio.natoIl, "YYYY-MM-DD"), 'years');
    if (age < 18) {
      return this.lang == "en" ? "minor" : "minore";
    }

    if (socio.idAssociazione > 0) {
      return this.lang == "en" ? "affiliated" : "convenzionato";
    } else {
      return this.lang == "en" ? "ordinary" : "ordinario";
    }

    
  }
}

@Pipe({
  name: 'assicurato'
})
export class AssicuratoPipe implements PipeTransform {

  transform(socio: any, args?: any): boolean {
    if (!socio || !socio.fineValidita)
      return false;

    return moment().isBefore(socio.fineValidita);
  }

}

@Pipe({
  name: 'inizioValidita'
})
export class InizioValiditaPipe implements PipeTransform {

  transform(data: string, args?: any): Date {

    var dataPagamento = moment(data);
    var result = dataPagamento.add(1, 'days');

    return result.toDate();
  }

}

@Pipe({
  name: 'fineValidita'
})
export class FineValiditaPipe implements PipeTransform {

  transform(data: string, args?: any): Date {

    var dataPagamento = moment(data);
    var mese = dataPagamento.month();
    if (mese >= 8)
      return new Date(dataPagamento.year() + 1, 11, 31);

    return new Date(dataPagamento.year(), 11, 31);
  }

}

